// extracted by mini-css-extract-plugin
export default {"Chip":"Chips_Chip__ktlH+"};